import { Fragment, useState } from 'react';
import { css } from '@emotion/css';
import { Dialog, Typography } from '@prezzee/components';
import { colors, spacing } from '@prezzee/tokens';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { make as RichText } from '@prezzee/ribbon/src/components/personal/RichText/RichText.gen';

import { useProduct } from 'contexts/ProductPageContext';
import wrapUrls from 'utils/wrapUrls';

const style = {
  dialogTrigger: css`
    text-decoration: underline;
    color: ${colors.notificationBlue};
    width: fit-content;
    margin-top: ${spacing.spacing04};

    :hover {
      cursor: pointer;
    }
  `,
  dialog: css`
    [role='dialog'] {
      padding: ${spacing.spacing06};
      max-height: 50%;
      max-width: 448px;
    }
  `,
  close: css`
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: ${colors.lilac50};
    position: absolute;
    right: ${spacing.spacing06};
    top: ${spacing.spacing06};
  `,
  title: css`
    margin-bottom: ${spacing.spacing05} !important;
    padding-right: 35px;
  `,
  terms: css`
    white-space: pre-wrap;

    a {
      color: ${colors.blue500};
      text-decoration: underline;

      &:hover {
        color: ${colors.blue600};
      }
    }
  `,
};

const RetailerTnCModal = (): JSX.Element => {
  const { sku } = useProduct();
  const [retailerTnCModalOpen, setRetailerTnCModalOpen] = useState<boolean>(false);
  const handleClose = () => setRetailerTnCModalOpen(false);
  const terms = sku?.merchant.terms;

  if (!terms) return null;

  return (
    <Fragment>
      <button
        onClick={() => {
          setRetailerTnCModalOpen(true);
        }}
        className={style.dialogTrigger}
      >
        Terms &amp; Conditions
      </button>
      <Dialog
        open={retailerTnCModalOpen}
        aria-labelledby="retailer-terms-and-conditions"
        className={style.dialog}
        onClose={handleClose}
      >
        <button
          className={style.close}
          onClick={handleClose}
          title="Close retailer terms and conditions dialog"
          aria-label="Close retailer terms and conditions dialog"
        >
          <FontAwesomeIcon icon={['far', 'times']} />
        </button>
        <Typography variant="h4" component="h3" id="retailer-list-dialog-title" className={style.title}>
          {`${sku.name} eGift Card Terms and Conditions`}
        </Typography>
        <RichText className={style.terms}>{wrapUrls(terms, true)}</RichText>
      </Dialog>
    </Fragment>
  );
};

export default RetailerTnCModal;
